import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { catchError } from 'rxjs/operators';
import { ChecklistCategoriesVM, ChecklistQuestionsVM, Department, DepartmentWorkAreasVM, GetMonthlyTargetListVM, IncidentType, MonthlyDashboardMessageVM, MonthlyHoursVM, SiteCodes, Task5Model, ToolboxTalkModel, WorkArea } from '../entities/global/model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Tuple } from '../setup-equipment/setup-equipment.model';


@Injectable()
export class SafetyConfigService {
   private data = new BehaviorSubject('');
   currentData = this.data.asObservable()

  constructor(private _http: Http) { }
  
  

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

public getAllSitesList_(): Observable<SiteCodes[]>
{
  return this._http.get('api/SafetyConfiguration/GetAllSitesList').share().map(
    (response: Response) => <SiteCodes[]>response.json()).catch(this.handleError);
}

public getAllSitesList(): Observable<SiteCodes[]> {
  return this._http.get('api/SafetyConfiguration/GetAllSitesList').share().map(
    (response: Response) => <SiteCodes[]>response.json()).catch(this.handleError);
}


// public getAllSitesList(): Observable<SiteCodes[]> {
//   return this._http.get('api/SafetyConfiguration/GetAllSitesList').share().map(
//     (response: Response) => <SiteCodes[]>response.json()).catch(this.handleError);
// }

public addTake5(params: Task5Model) {
  return this._http.post('api/SafetyConfiguration/AddTake5sSubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public addToolBoxTalk(params: ToolboxTalkModel) {
  return this._http.post('api/SafetyConfiguration/AddToolBoxTalkSubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public addMonthlyDashboardMessage(params: MonthlyDashboardMessageVM) {
  return this._http.post('api/SafetyConfiguration/AddMonthlyDashboardSubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public GetMonthlyTargetList(Id:number, month:number, year:number): Observable<GetMonthlyTargetListVM[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', "" + Id);
  params.set('month', "" + month);
  params.set('year', "" + year);

  return this._http.get("api/SafetyDashboard/GetSafetyFutureTargets",{ search: params }).share().map(
    (response: Response) => <GetMonthlyTargetListVM[]>response.json()).catch(this.handleError);
}



public checkMonthlyDashboardMessagesubmit(params: MonthlyDashboardMessageVM) {
  return this._http.post('api/SafetyConfiguration/CheckMonthlyDashboardMessages', params).share().map(
      (response: Response) => <MonthlyDashboardMessageVM>response.json()).catch(this.handleError);
}

public addMonthlyHours(params: MonthlyHoursVM) {
  return this._http.post('api/SafetyConfiguration/AddMonthlyHoursSubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}


public addCategory(params: ChecklistCategoriesVM) {
  return this._http.post('api/SafetyConfiguration/CreateCategorySubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public GetAllCategoriesList(): Observable<ChecklistCategoriesVM[]> {
  return this._http.get('api/SafetyConfiguration/GetAllCategoriesList').share().map(
    (response: Response) => <ChecklistCategoriesVM[]>response.json()).catch(this.handleError);
}

public addQuestion(params: ChecklistQuestionsVM) {
  return this._http.post('api/SafetyConfiguration/CreateQuestionSubmit', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public GetAllQuestionsList(): Observable<ChecklistQuestionsVM[]> {
  return this._http.get('api/SafetyConfiguration/GetAllQuestionsList').share().map(
    (response: Response) => <ChecklistQuestionsVM[]>response.json()).catch(this.handleError);
}

public updateCategory(params: ChecklistCategoriesVM) {
  return this._http.post('api/SafetyConfiguration/UpdateCategoryDetails', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public GetDepartmentsAndWorkAreas(): Observable<DepartmentWorkAreasVM> {
  return this._http.get("api/SafetyConfiguration/GetDepartmentsAndWorkAreas").share().map(
    (response: Response) => <DepartmentWorkAreasVM>response.json()).catch(this.handleError);
}
public CreateIncidentType(params: IncidentType): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/CreateIncidentType", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public UpdateIncidentType(params: IncidentType): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/UpdateIncidentType", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public Get(): Observable<IncidentType[]> {
  return this._http.get('api/SafetyConfiguration/Get').share().map(
    (response: Response) => <IncidentType[]>response.json()).catch(this.handleError);
}
public ToggleTRIFR(params: IncidentType): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/ToggleTRIFR", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public updateQuestion(params: ChecklistQuestionsVM) {
  return this._http.post('api/SafetyConfiguration/UpdateQuestionDetails', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
}

public CreateDepartment(newSection: Department): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/CreateDepartment", newSection).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public CreateWorkArea(newSection: WorkArea): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/CreateWorkArea", newSection).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public UpdateDepartment(params: Department): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/UpdateDepartment", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}
public UpdateWorkArea(params: WorkArea): Observable<Tuple> {
  return this._http.post("api/SafetyConfiguration/UpdateWorkArea", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}
public GetAllMonthlyHOurs(params: MonthlyHoursVM) {
  return this._http.post('api/SafetyConfiguration/GetAllMonthlyHOurs', params).share().map(
      (response: Response) => <MonthlyHoursVM>response.json()).catch(this.handleError);
}

}
